import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export const downloadRollNos_PDF = ({ 
    reportData, 
    summReportData, 
    instituteName, 
    selectedYear1, 
    selectedStdName, 
    selectedDivName, }) => {

    const doc = new jsPDF("portrait", "mm", "a4");

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    //-----------------------------------------------------
    // Settings
    //-----------------------------------------------------

    const ROWS_PER_PAGE = 22;

    const schoolName = instituteName;

    const yearText =
        `${selectedYear1}-${Number(selectedYear1) + 1}`;

    const now = new Date();

    const generatedOn = now.toLocaleString("en-IN");

    //-----------------------------------------------------
    // Split Data (22 rows per page)
    //-----------------------------------------------------

    const pages = [];

    for (let i = 0; i < reportData.length; i += ROWS_PER_PAGE) {

        pages.push(
            reportData.slice(i, i + ROWS_PER_PAGE)
        );

    }

    const totalPages = pages.length;

    //-----------------------------------------------------
    // Draw Header
    //-----------------------------------------------------

    const drawHeader = (pageNo) => {

        doc.setFont("helvetica", "bold");
        //doc.setFont("times", "bold");
        doc.setFontSize(12);

        doc.text(
            schoolName,
            pageWidth / 2,
            10,
            {
                align: "center"
            }
        );

        doc.setFontSize(9);
        doc.setFont("helvetica", "normal");
        //doc.setFont("times", "normal");

        doc.text(
            `Year : ${yearText}`,
            14,
            17
        );

        doc.text(
            `Roll Number Listing for Std / Div : ${selectedStdName} / ${selectedDivName}`,
            pageWidth / 2,
            17,
            {
                align: "center"
            }
        );

        doc.text(
            `Page ${pageNo}/${totalPages}`,
            pageWidth - 14,
            17,
            {
                align: "right"
            }
        );

        doc.setDrawColor(0);

        doc.line(
            14,
            21,
            pageWidth - 14,
            21
        );

    };

    //-----------------------------------------------------
    // Draw Footer
    //-----------------------------------------------------

    const drawFooter = () => {

        doc.setFontSize(6);

        doc.setFont("helvetica", "normal");

        doc.line(
            14,
            pageHeight - 8,
            pageWidth - 14,
            pageHeight - 8
        );

        doc.text(
            "eSchool",
            14,
            pageHeight - 4
        );

        doc.text(
            `Generated : ${generatedOn}`,
            pageWidth / 2,
            pageHeight - 4,
            {
                align: "center"
            }
        );

    };

    //-----------------------------------------------------
    // Generate each page
    //-----------------------------------------------------

    pages.forEach((rows, pageIndex) => {

        if (pageIndex > 0) {
            doc.addPage();
        }

        drawHeader(pageIndex + 1);

        autoTable(doc, {

            startY: 28,
            theme: "grid",

            head: [[
                "Roll No",
                "GR No",
                "Student Name\nAddress",
                "Birth Date\nStudent Id",
                "Gender",
                "House"
            ]],

            body: rows.map((r) => [
                r.roll_no,
                r.gr_no,
                `${r.stud_name}
${r.stud_addr1}
${r.stud_addr2}`,
                `${r.birth_date}
${r.stud_id}`,
                r.gender,
                r.house
            ]),

            styles: {

                font: "helvetica",
                //font: "times",
                fontSize: 7,
                cellPadding: 1,
                overflow: "linebreak",
                valign: "middle",
                textColor: 0,
                lineColor: [0, 0, 0],
                lineWidth: 0.1,
                minCellHeight: 7

            },

            headStyles: {

                fillColor: [235, 235, 235],
                textColor: 0,
                fontStyle: "bold",
                halign: "center",
                valign: "middle",
                lineColor: [0, 0, 0],
                lineWidth: 0.2

            },

            bodyStyles: {
                textColor: 0
            },

            columnStyles: {

                0: {
                    cellWidth: 18,
                    halign: "center"
                },

                1: {
                    cellWidth: 18,
                    halign: "center"
                },

                2: {
                    cellWidth: 82,
                    halign: "left"
                },

                3: {
                    cellWidth: 28,
                    halign: "center"
                },

                4: {
                    cellWidth: 18,
                    halign: "center"
                },

                5: {
                    cellWidth: 18,
                    halign: "center"
                }

            },

            margin: {
                left: 14,
                right: 14
            },

            pageBreak: "avoid",
            rowPageBreak: "avoid",

        });

        // ----------------------------------------------------
        // House Summary (Last Page)
        // ----------------------------------------------------
        if (pageIndex === totalPages - 1 && summReportData.length > 0) {

            // If there isn't enough space, create a new page
            const requiredHeight = 20 + (summReportData.length * 8);

            if (doc.lastAutoTable.finalY + requiredHeight > pageHeight - 20) {
                doc.addPage();
                drawHeader(totalPages + 1);
            }

            doc.setFont("helvetica", "bold");
            doc.setFontSize(9);

            doc.text(
                "House Summary",
                14,
                doc.lastAutoTable.finalY + 6
            );

            autoTable(doc, {
                startY: doc.lastAutoTable.finalY + 8,

                theme: "grid",

                head: [["House", "Count"]],

                body: summReportData.map((r) => [
                    r.house,
                    r.stud_count
                ]),

                styles: {
                    font: "helvetica",
                    fontSize: 8,
                    cellPadding: 2,
                    lineColor: [0, 0, 0],
                    lineWidth: 0.1,
                    textColor: 0
                },

                headStyles: {
                    fillColor: [235, 235, 235],
                    textColor: 0,
                    fontStyle: "bold",
                    halign: "center"
                },

                columnStyles: {
                    0: { cellWidth: 30, halign: "left" },
                    1: { cellWidth: 18, halign: "right" }
                },

                margin: {
                    left: 14
                },

                tableWidth: 48
            });
        }


        drawFooter();

    });

    //-----------------------------------------------------
    // Save PDF
    //-----------------------------------------------------

    const fileName =
        `Roll_Number_Listing_${selectedStdName}_${selectedDivName}_${yearText}.pdf`;

    doc.save(fileName);

};
